<ng-lottie
  [options]="options"
  (animationCreated)="animationCreated($event)"
  containerClass="loader-box"
>
</ng-lottie>
